<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">线路管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="线路名称" prop="LineName">
            <el-input
              v-model="LineName"
              placeholder="请输入线路名称"
            ></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="LineId" label="线路编号"></el-table-column>
              <el-table-column
                prop="LineName"
                label="线路名称"
              ></el-table-column>
              <el-table-column
                prop="UpMil"
                label="上行总里程(km)"
              ></el-table-column>
              <el-table-column
                prop="DownMil"
                label="下行总里程(km)"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "LineManagerView",
  controller: "UI",
  action: "LineManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      LineName: "",
    };
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "线路管理查询";
    this.logInfo.LogMessage = "线路管理查询";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "线路管理列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        LineName: this.LineName,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.LinesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/vehicleScheduling/UI/LineManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/LineManagerInfo",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/LineManagerInfo",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    //线路已维护站台，不能删除
    canDelete(selectData, callback) {
      let canDelete = true;
      new MyApis.LineStationRelationApi()
        .GetItemPagingList({
          LineId: selectData.ID,
        })
        .then((r) => {
          r = r.data.Data;
          const data = r.PageContents;
          if (data != null && data.length > 0) {
            this.$message.error("该线路已维护了站台，请先删除线路站台关系。");
            canDelete = false;
          }
          callback(canDelete);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const that = this;
          that.canDelete(row, function(data) {
            if (data) {
              new MyApis.LinesApi()
                .DelItem(row)
                .then((r) => {
                  r = r.data.Data;
                  if (r) {
                    that.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    that.logInfo.ActionName = "线路删除";
                    that.logInfo.LogMessage = "线路删除";
                    that.logInfo.ModuleName = "车辆调度";
                    that.logInfo.PageName = "线路管理列表";
                    that.addOperationLog();
                  } else {
                    that.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                  that.search();
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.LineName = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
